<h4 mat-dialog-title>Are you sure you would like to send this Rate Con Report?</h4>

<mat-dialog-content>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="btn btn-primary" (click)="confirmRatecon()">Yes</button>
    <button class="btn btn-secondary" (click)="cancelRatecon()">No</button>
</mat-dialog-actions>
